__webpack_require__.p = "/tokens-buttons-figma-alignement/system-email-templates/";